// extracted by mini-css-extract-plugin
export default {"gameHeadingBox":"bingo_gameHeadingBox__gjzP1","hide":"bingo_hide__6HQE0","task":"bingo_task__U6Rvx"};